var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmationAppl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 224,
    viewBox: "0 0 224 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 112.001,
    cy: 112,
    r: 112,
    fill: "#ECFDF3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.001,
    cy: 112,
    r: 81,
    fill: "#D1FADF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_439_5968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.501 79.7502H122.106C120.601 75.5935 116.659 72.5835 112.001 72.5835C107.343 72.5835 103.401 75.5935 101.896 79.7502H90.5011C86.5595 79.7502 83.3345 82.9752 83.3345 86.9168V140.667C83.3345 144.608 86.5595 147.833 90.5011 147.833H112.395C110.281 145.791 108.561 143.354 107.307 140.667H90.5011V86.9168H97.6678V90.5002C97.6678 94.4418 100.893 97.6668 104.834 97.6668H119.168C123.109 97.6668 126.334 94.4418 126.334 90.5002V86.9168H133.501V105.12C136.045 105.478 138.446 106.231 140.668 107.27V86.9168C140.668 82.9752 137.443 79.7502 133.501 79.7502ZM112.001 86.9168C110.03 86.9168 108.418 85.3043 108.418 83.3335C108.418 81.3627 110.03 79.7502 112.001 79.7502C113.972 79.7502 115.584 81.3627 115.584 83.3335C115.584 85.3043 113.972 86.9168 112.001 86.9168ZM129.918 112C120.028 112 112.001 120.027 112.001 129.917C112.001 139.807 120.028 147.833 129.918 147.833C139.808 147.833 147.834 139.807 147.834 129.917C147.834 120.027 139.808 112 129.918 112ZM134.54 137.083L128.628 131.171C128.305 130.848 128.09 130.383 128.09 129.917V120.994C128.09 119.991 128.879 119.203 129.882 119.203C130.885 119.203 131.674 119.991 131.674 120.994V129.2L137.049 134.575C137.765 135.292 137.765 136.403 137.049 137.119C136.368 137.8 135.257 137.8 134.54 137.083Z",
    fill: "#52AD33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_439_5968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 86,
    fill: "white",
    transform: "translate(69.001 69)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationAppl);
export default __webpack_public_path__ + "static/media/ConfirmationAppl.4762dff8fc77b205d4e1438796035b14.svg";
export { ForwardRef as ReactComponent };